﻿import { Timeline, type DataItem, type TimelineOptions } from 'vis-timeline';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';

interface DotNetRef {
    invokeMethodAsync(methodName: string, ...args: unknown[]): Promise<unknown>;
}

function createDefaultItems(): DataItem[] {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);

    return [
        { id: '1', content: 'Started', start: yesterday },
        { id: '2', content: 'In progress', start: now },
        { id: '3', content: 'Next step', start: tomorrow }
    ];
}

class OmVisTimeLine {
    private readonly timeline: Timeline;

    constructor(elementId: string, dotNetRef?: DotNetRef, items: DataItem[] = createDefaultItems(), options?: TimelineOptions) {
        const element = document.getElementById(elementId);
        if (!element) {
            throw new Error(`VisTimeLine container with id '${elementId}' was not found.`);
        }

        this.timeline = new Timeline(element, items, {
            stack: false,
            ...options
        });

        if (dotNetRef) {
            this.timeline.on('select', (properties) => {
                const selectedItemId = properties.items[0];
                if (selectedItemId) {
                    dotNetRef.invokeMethodAsync('OnItemClicked', selectedItemId.toString());
                }
            });
        }
    }

    public setItems(items: DataItem[]): void {
        this.timeline.setItems(items);
        this.timeline.fit();
    }

    public destroy(): void {
        this.timeline.destroy();
    }
}

export function Create(elementId: string, dotNetRef?: DotNetRef, items?: DataItem[], options?: TimelineOptions): OmVisTimeLine {
    return new OmVisTimeLine(elementId, dotNetRef, items, options);
}

export function SetItems(visTimeLine: OmVisTimeLine, items: DataItem[]): void {
    visTimeLine.setItems(items);
}

export function Destroy(visTimeLine: OmVisTimeLine): void {
    visTimeLine.destroy();
}

export default {
    Create,
    SetItems,
    Destroy
};
